// extracted by mini-css-extract-plugin
export default {"lz_sub-menu-container":"SubMenu_lz_sub-menu-container__SLuyj","lz_sub-menu-title":"SubMenu_lz_sub-menu-title__rNRsk","lz_sub-menu":"SubMenu_lz_sub-menu__GoURE"};